import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const scrollToSection = (sectionId: string) => {
    setIsOpen(false);
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        element?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className="fixed top-0 left-0 right-0 bg-navy text-white z-50 shadow-lg" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="flex justify-between items-center h-16" data-id="element-102">
          <Link to="/" className="text-lg font-serif font-bold" data-id="element-103">
            MerchantPro
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-104">
            <button onClick={() => scrollToSection('inicio')} className="hover:text-gold transition-colors" data-id="element-105">
              Inicio
            </button>
            <button onClick={() => scrollToSection('servicios')} className="hover:text-gold transition-colors" data-id="element-106">
              Servicios
            </button>
            <button onClick={() => scrollToSection('como-funciona')} className="hover:text-gold transition-colors" data-id="element-107">
              Cómo Funciona
            </button>
            <Link to="/contacto" className="hover:text-gold transition-colors" data-id="element-108">
              Contacto
            </Link>
            <Link to="/contacto" className="bg-gold text-navy px-6 py-2 rounded-md font-semibold hover:bg-opacity-90 transition-all" data-id="element-109">
              Evaluación Gratis
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2" aria-label="Toggle menu" data-id="element-110">
            {isOpen ? <X size={24} data-id="element-111" /> : <Menu size={24} data-id="element-112" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence data-id="element-113">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-darkGray" data-id="element-114">
            <div className="px-4 py-4 space-y-3" data-id="element-115">
              <button onClick={() => scrollToSection('inicio')} className="block w-full text-left py-2 hover:text-gold transition-colors" data-id="element-116">
                Inicio
              </button>
              <button onClick={() => scrollToSection('servicios')} className="block w-full text-left py-2 hover:text-gold transition-colors" data-id="element-117">
                Servicios
              </button>
              <button onClick={() => scrollToSection('como-funciona')} className="block w-full text-left py-2 hover:text-gold transition-colors" data-id="element-118">
                Cómo Funciona
              </button>
              <Link to="/contacto" onClick={() => setIsOpen(false)} className="block py-2 hover:text-gold transition-colors" data-id="element-119">
                Contacto
              </Link>
              <Link to="/contacto" onClick={() => setIsOpen(false)} className="block bg-gold text-navy px-6 py-2 rounded-md font-semibold text-center hover:bg-opacity-90 transition-all" data-id="element-120">
                Evaluación Gratis
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}